import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Injectable, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class PageTitleService implements OnInit {
  public title: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute) { }

  setTitle(value: string) {
    this.title.next(value);
  }

  getTitle(): string {
    return this.title.value;
  }

  ngOnInit() {
    this.router.events
      .filter((event) => event instanceof NavigationEnd)
      .map(() => this.activatedRoute)
      .map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      })
      .filter((route) => route.outlet === 'primary')
      .mergeMap((route) => route.data)
      .subscribe((event) => {
        this.setTitle(event['title']);
      });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/pageTitle.service.ts